import React from 'react';
import { useNavigate } from 'react-router-dom';

const RingCentralIntegration = () => {
  const navigate = useNavigate();

  return (
    <div className="demo-info-container" style={{ maxWidth: 1235, margin: '20px auto', background: '#fff', padding: '18px 24px', borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 6 }}>
        <img src="/assets/img/ringcentral.png" alt="RingCentral Logo" style={{ width: 110, objectFit: 'contain', margin: 0 }} />
        <h1 style={{ color: '#000', fontWeight: 600, fontSize: 24, margin: 0 }}>RingCentral Chat Demo</h1>
      </div>
      <p style={{ fontSize: 15, margin: '0 0 12px 0', color: '#444', lineHeight: 1.4 }}>
        The chatbot will initially assist you in answering your questions. If you wish, you can ask to be connected with a human advisor (depending on the availability of agents at the contact center).
      </p>
      <div style={{ width: '100%', height: 624, borderRadius: 12, overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
        <iframe
          src="https://smartly.ai/demo/ooredoo"
          title="RingCentral Demo"
          style={{ width: '100%', height: '100%', border: 'none', background: '#fafbfc' }}
          allow="clipboard-write; microphone; camera;"
        />
      </div>
    </div>
  );
};

export default RingCentralIntegration;
